(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["immersive-coverflow"] && !Shopify.designMode) return;
  try {
    
  function initImmersiveCoverflow(root) {
    if (root.dataset.immersiveInitialized === 'true') return;
    root.dataset.immersiveInitialized = 'true';

    const rail = root.querySelector('[id^="immersive-rail-"]');
    const prevBtn = root.querySelector('[id^="immersive-prev-"]');
    const nextBtn = root.querySelector('[id^="immersive-next-"]');
    if (!rail) return;

    const cards = [...rail.querySelectorAll('.immersive-card')]; // real cards only, in author order
    if (cards.length === 0) return;

    const loopable = cards.length > 1;
    let beforeClones = [];
    let afterClones = [];

    function makeClone(card) {
      const clone = card.cloneNode(true);
      clone.dataset.isClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      [...clone.attributes].forEach((attr) => {
        if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
      });
      return clone;
    }

    if (loopable) {
      // Duplicate the full card set on both sides so scrolling past either end
      // of the real set lands on look-alike clones instead of empty space —
      // the illusion of an infinite loop. checkLoopReposition() below silently
      // snaps back into the real set once a clone becomes the active card.
      beforeClones = cards.map(makeClone);
      afterClones = cards.map(makeClone);
      beforeClones.forEach((clone) => rail.insertBefore(clone, rail.firstChild));
      afterClones.forEach((clone) => rail.appendChild(clone));
    }

    const allCards = [...rail.querySelectorAll('.immersive-card')];

    let activeIndex = -1;
    let activeEl = null;
    let raf = null;

    function updateActive() {
      const railRect = rail.getBoundingClientRect();
      const centerX = railRect.left + railRect.width / 2;
      let bestEl = allCards[0];
      let bestDist = Infinity;

      allCards.forEach((card) => {
        const r = card.getBoundingClientRect();
        const dist = Math.abs((r.left + r.right) / 2 - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          bestEl = card;
        }
      });

      if (bestEl !== activeEl) {
        activeEl = bestEl;
        allCards.forEach((card) => {
          const isActive = card === activeEl;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        const realIndex = Number(activeEl.dataset.cardIndex);
        if (realIndex !== activeIndex) {
          activeIndex = realIndex;
          rail.dispatchEvent(new CustomEvent('immersive:card-activated', {
            detail: { index: activeIndex, cardEl: activeEl },
          }));
        }
      }
    }

    function loopSpan() {
      // Distance between a real card and its same-index clone in the next set —
      // equal to the width of one full card set (cards + gaps) since the rail
      // is one continuous flex row with a uniform gap throughout.
      if (!loopable) return 0;
      return cards[0].getBoundingClientRect().left - beforeClones[0].getBoundingClientRect().left;
    }

    let settleTimer = null;
    function checkLoopReposition() {
      if (!loopable || !activeEl) return;
      const span = loopSpan();
      if (!span) return;
      if (beforeClones.includes(activeEl)) {
        rail.scrollLeft += span;
        updateActive();
      } else if (afterClones.includes(activeEl)) {
        rail.scrollLeft -= span;
        updateActive();
      }
    }

    rail.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActive);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(checkLoopReposition, 120);
    });

    // Cards start veiled (blurred/dimmed); reveal on the visitor's first scroll
    // interaction, whether it came from the wheel handler below, a touch swipe
    // (native overflow-x scrolling), or the prev/next arrows.
    rail.addEventListener('scroll', () => rail.classList.remove('is-veiled'), { once: true });

    window.addEventListener('resize', updateActive);

    // Let a vertical mouse wheel drive the horizontal rail (trackpad horizontal
    // swipes already scroll the rail natively via overflow-x, so only take over
    // when the wheel's dominant axis is vertical).
    rail.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      e.preventDefault();
      rail.scrollLeft += e.deltaY;
    }, { passive: false });

    function cardStep() {
      return cards[0].getBoundingClientRect().width + 48; // card width + gap
    }

    if (nextBtn) nextBtn.addEventListener('click', () => rail.scrollBy({ left: cardStep(), behavior: 'smooth' }));
    if (prevBtn) prevBtn.addEventListener('click', () => rail.scrollBy({ left: -cardStep(), behavior: 'smooth' }));

    allCards.forEach((card) => {
      card.addEventListener('click', (e) => {
        const isHashLink = card.getAttribute('href') === '#';
        if (!card.classList.contains('is-active')) {
          e.preventDefault();
          // rail.scrollLeft (not card.scrollIntoView, which also scrolls the
          // page/ancestors vertically into view — see the page-load fix above
          // for why that's unsafe here).
          const target = card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2;
          rail.scrollTo({ left: target, behavior: 'smooth' });
        } else if (isHashLink) {
          e.preventDefault();
        }
      });
    });

    cards.forEach((card) => {
      card.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const dir = e.key === 'ArrowRight' ? 1 : -1;
          rail.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
          rail.addEventListener('immersive:card-activated', (activatedEvent) => {
            const focusedCard = cards[activatedEvent.detail.index];
            if (focusedCard) focusedCard.focus();
          }, { once: true });
        }
      });
    });

    // Start centered on the first real card (not the first clone) so the loop
    // is invisible on load. Set the rail's own scrollLeft directly rather than
    // cards[0].scrollIntoView() — scrollIntoView also scrolls ancestor/page
    // scroll containers into view, which yanked the whole page down to this
    // section on load (this section sits further down the homepage, so on
    // first paint it isn't in the viewport yet and scrollIntoView "fixed"
    // that by scrolling the page — confirmed as a mobile bug in production).
    rail.scrollLeft = cards[0].offsetLeft - (rail.clientWidth - cards[0].offsetWidth) / 2;
    requestAnimationFrame(updateActive);

    const bgStack = root.querySelector('[id^="immersive-bgstack-"]');
    // The templates root renders as a sibling of the section element (outside it, in the
    // markup below), not a descendant, so it can't be found via root.querySelector.
    // Look it up at the document level, scoped by the section id shared with the rail's id.
    const sectionIdSuffix = rail.id.replace('immersive-rail-', '');
    const bgTemplatesRoot = document.getElementById('immersive-bg-templates-' + sectionIdSuffix);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (bgStack && bgTemplatesRoot) {
      const templates = new Map(
        [...bgTemplatesRoot.querySelectorAll('template')].map((t) => [Number(t.dataset.bgIndex), t])
      );
      const mounted = new Map(); // index -> mounted element

      function mount(index) {
        if (mounted.has(index) || !templates.has(index)) return;
        const node = templates.get(index).content.cloneNode(true);
        const wrapper = document.createElement('div');
        wrapper.className = 'immersive-bg';
        wrapper.dataset.bgIndex = String(index);
        wrapper.appendChild(node);
        if (reduceMotion) {
          wrapper.querySelectorAll('video').forEach((v) => v.removeAttribute('autoplay'));
        }
        bgStack.appendChild(wrapper);
        mounted.set(index, wrapper);
      }

      function unmount(index) {
        const wrapper = mounted.get(index);
        if (!wrapper) return;
        wrapper.querySelectorAll('video').forEach((v) => v.pause());
        wrapper.remove();
        mounted.delete(index);
      }

      function setActiveBg(index) {
        const n = cards.length;
        const neighbors = loopable
          ? [index - 1, index, index + 1].map((i) => (i + n) % n)
          : [index - 1, index, index + 1].filter((i) => i >= 0 && i < n);
        neighbors.forEach(mount);
        [...mounted.keys()].forEach((i) => {
          if (!neighbors.includes(i)) unmount(i);
        });
        mounted.forEach((wrapper, i) => wrapper.classList.toggle('is-active', i === index));
      }

      setActiveBg(0);
      rail.addEventListener('immersive:card-activated', (e) => setActiveBg(e.detail.index));
    }
  }

  document.querySelectorAll('.immersive-coverflow').forEach(initImmersiveCoverflow);
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.immersive-coverflow');
    if (root) initImmersiveCoverflow(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
